export default "__VITE_ASSET__GAU6yK5L__"